import React, { useEffect, useState } from "react";
import {
    Box,
    Heading,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Spinner,
    Text,
    Badge,
    Flex,
    Button,
    useDisclosure,
    useToast,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuDivider,
} from "@chakra-ui/react";
import { FiUsers, FiCopy, FiChevronDown } from "react-icons/fi";
import { listarCotacoes, listarFornecedoresCotacao } from "../services/api";
import ConfiguracoesFornecedoresCotacao from "../components/ConfiguracoesFornecedoresCotacao";
import { useNavigate } from "react-router-dom";

export default function ListarCotacoes() {
    const [cotacoes, setCotacoes] = useState([]);
    const [fornecedores, setFornecedores] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();

    useEffect(() => {
        async function fetchData() {
            const [data, forns] = await Promise.all([
                listarCotacoes(),
                listarFornecedoresCotacao(),
            ]);
            setCotacoes(data);
            setFornecedores((forns || []).filter((f) => f.ativo));
            setLoading(false);
        }
        fetchData();
    }, []);

    // Mesmo link enviado por WhatsApp: sem o fornecedor a resposta entra como "Desconhecido"
    const montarLink = (token, fornecedor) => {
        const base = `${window.location.origin}/responder-cotacao/${token}`;
        if (!fornecedor) return base;
        return `${base}?fornecedor=${encodeURIComponent(fornecedor.nome)}&whatsapp=${encodeURIComponent(fornecedor.whatsapp)}`;
    };

    const copiarLink = async (token, fornecedor) => {
        const link = montarLink(token, fornecedor);
        try {
            await navigator.clipboard.writeText(link);
            toast({
                title: "Link copiado!",
                description: fornecedor ? `Link do fornecedor ${fornecedor.nome}.` : "Link sem fornecedor.",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } catch {
            toast({
                title: "Não foi possível copiar",
                description: link,
                status: "error",
                duration: 10000,
                isClosable: true,
            });
        }
    };

    return (
        <Flex minH="100vh" align="center" justify="center" bg="gray.50" py={10} px={4}>
            <Box bg="white" p={8} borderRadius="xl" shadow="lg" w="full" maxW="1000px">
                <Flex mb={6} align="center" justify="space-between" gap={3} flexWrap="wrap">
                    <Heading flex="1" textAlign="center">
                        Cotações Cadastradas
                    </Heading>
                    <Button
                        size="sm"
                        leftIcon={<FiUsers />}
                        colorScheme="green"
                        bg="#01695E"
                        onClick={onOpen}
                    >
                        Fornecedores
                    </Button>
                </Flex>

                {loading ? (
                    <Flex justify="center" mt={6}>
                        <Spinner size="xl" />
                    </Flex>
                ) : cotacoes.length === 0 ? (
                    <Text textAlign="center">Nenhuma cotação encontrada.</Text>
                ) : (
                    <Box overflowX="auto">
                        <Table variant="simple">
                            <Thead bg="gray.100">
                                <Tr>
                                    <Th>ID</Th>
                                    <Th>Usuário</Th>
                                    <Th>Pedido</Th> 
                                    <Th>Status</Th>
                                    <Th>Token</Th>
                                    <Th>Data</Th>
                                    <Th>Ações</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {cotacoes.map((cotacao) => (
                                    <Tr key={cotacao.id}>
                                        <Td>{cotacao.id}</Td>
                                        <Td>{cotacao.user?.name || "Desconhecido"}</Td>
                                        <Td>{cotacao.pedido_origem || "Não tem"}</Td>
                                        <Td>
                                            <Badge
                                                colorScheme={
                                                    cotacao.status === "pendente"
                                                        ? "yellow"
                                                        : cotacao.status === "enviada"
                                                            ? "blue"
                                                            : "green"
                                                }
                                            >
                                                {cotacao.status}
                                            </Badge>

                                        </Td>
                                        <Td>{cotacao.token}</Td>
                                        <Td>{new Date(cotacao.created_at).toLocaleString()}</Td>
                                        <Td>
                                            <Flex gap={2} flexWrap="wrap">
                                                <Button
                                                    size="sm"
                                                    colorScheme="blue"
                                                    onClick={() => navigate(`/cotacoes/${cotacao.token}`)}
                                                >
                                                    Ver Respostas
                                                </Button>
                                                <Menu>
                                                    <MenuButton
                                                        as={Button}
                                                        size="sm"
                                                        variant="outline"
                                                        colorScheme="teal"
                                                        leftIcon={<FiCopy />}
                                                        rightIcon={<FiChevronDown />}
                                                    >
                                                        Copiar link
                                                    </MenuButton>
                                                    <MenuList maxH="300px" overflowY="auto">
                                                        {fornecedores.map((f) => (
                                                            <MenuItem
                                                                key={f.id}
                                                                onClick={() => copiarLink(cotacao.token, f)}
                                                            >
                                                                {f.nome}
                                                            </MenuItem>
                                                        ))}
                                                        {fornecedores.length > 0 && <MenuDivider />}
                                                        <MenuItem onClick={() => copiarLink(cotacao.token, null)}>
                                                            Sem fornecedor
                                                        </MenuItem>
                                                    </MenuList>
                                                </Menu>
                                            </Flex>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                )}
            </Box>

            <ConfiguracoesFornecedoresCotacao isOpen={isOpen} onClose={onClose} />
        </Flex>
    );
}
